import * as api from "./_DATA";

export function generateUID():any {
  try {
    return api.generateUID();
  } catch (error) {
    // TODO
  }
}

export function getUsers():any {
  try {
    return api._getUsers();
  } catch (error) {
    // TODO
  }
}

export function getQuestions():any {
  try {
    return api._getQuestions();
  } catch (error) {
    // TODO
  }
}

export function saveQuestion(question:any):any {
  try {
    return api._saveQuestion(question);
  } catch (error) {
    // TODO
  }
}

export function saveQuestionAnswer({ authedUser, qid, answer }:{ authedUser:any, qid:any, answer:any }):any {
  try {
    return api._saveQuestionAnswer({ authedUser, qid, answer });
  } catch (err) {
    // TODO
  }
}
